<div class="campanha-table">
    <table class="table table-striped table-hover table-bordered" id="campanhaTable">
        <thead>
            <tr>
                <th class="col-options row-span-2" rowspan="2"></th>
                <th class="col-numero row-span-2" rowspan="2">Número</th>
                <th class="col-nome row-span-2" rowspan="2">Nome</th>
                <th class="col-status text-center row-span-2" rowspan="2">Status</th>
                <th class="col-nome-area row-span-2" rowspan="2">Área</th>
                <th class="col-nome-pacote row-span-2" rowspan="2">Pacote</th>                
                <th class="col-objetivo text-center" colspan="3">Objetivos</th>
                <th class="col-vigencia text-center" colspan="3">Vigência</th>
                <th class="col-roi-recursos text-right row-span-2" rowspan="2">Recursos</th>
                <th class="col-roi-resultado text-right row-span-2" rowspan="2">Resultado</th>
                <th class="col-roi text-right row-span-2" rowspan="2">ROI</th>   
            </tr>
            <tr>
                <th class="col-objetivo col-objetivo-venda">Venda?</th>
                <th class="col-objetivo col-objetivo-bonificacao">Bonificação/Amostra?</th>
                <th class="col-objetivo col-objetivo-aquisicao">Aquisição?</th>
                <th class="col-vigencia col-vigencia-recorrente">Recorrente?</th>
                <th class="col-vigencia col-data-inicio-vigencia text-center">Início</th>
                <th class="col-vigencia col-data-termino-vigencia text-center">Término</th>
            </tr>
        </thead>
        <tfoot>
            <tr>
                <td class="col-options"></td>
                <td class="col-numero"></td>
                <td class="col-nome"></td>
                <td colspan="9" class="text-center">
                    {{total?.quantidade | decimalFormat: 1:0:0}} campanhas(s)
                </td>
                <td class="col-roi col-roi-recursos text-right">
                    {{total?.resultado?.roi?.valorTotalDespesas | currencyFormat: 1:2:2}}
                </td>
                <td class="col-roi col-roi-resultado text-right">
                    {{total?.resultado?.roi?.valorTotalVendas | currencyFormat: 1:2:2}}
                </td>
                <td class="col-roi col-roi-roi text-right">
                    {{total?.resultado?.roi?.retornoEfetivo | decimalFormat: 1:2:2}}x
                </td>                                              
            </tr>
        </tfoot>
    </table>         
</div>

<!-- Container para criar dinamicamente o badge do status -->
<ng-template #badgeStatusContainer></ng-template>

<!-- Enviar Análise -->
<sgt-campanha-enviar-analise-form-modal
    #enviarAnaliseFormModal
    (afterEnviarAnalise)="onAfterEnviarAnalise($event)">
</sgt-campanha-enviar-analise-form-modal>


<!-- Visualizar Campanha -->
<sgt-campanha-visualizar-modal
    #visualizarModal
    (afterLiberarPedidos)="afterLiberarPedidos()">
</sgt-campanha-visualizar-modal>